<template>
  <modal v-model="show"
         :width="width"
         persistent
         :content-class="getModalClass()">

    <button v-if="dataActivatorText"
            class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset()">
      {{dataActivatorText}}
    </button>

    <app-device-edit-body @close="closeModal"
                          v-if="editMode"></app-device-edit-body>
    <app-device-create-body @close="closeModal"
                            v-if="createMode"></app-device-create-body>
    <app-device-settings-body @close="closeModal"
                              :userId="userId"
                              v-if="settingsMode"></app-device-settings-body>
    <app-device-connection-support-body @close="closeModal"
                                        v-if="connectionSupportMode"></app-device-connection-support-body>

  </modal>
</template>

<script>
import AppDeviceCreateBody from "./components/DeviceCreateBody";
import AppDeviceEditBody from "./components/DeviceEditBody";
import AppDeviceSettingsBody from "./components/DeviceSettingsBody";
import AppDeviceConnectionSupportBody from "./components/DeviceEditConnectionSupportBody";
import EventBus from "@packages/event-bus/index";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    AppDeviceCreateBody,
    AppDeviceEditBody,
    AppDeviceSettingsBody,
    AppDeviceConnectionSupportBody,
    Modal,
  },

  data() {
    return {
      show: false,
      mode: null,
      userId: undefined,
    };
  },

  props: {
    dataActivatorText: {
      type: String,
    },
  },

  computed: {
    createMode() {
      return this.mode === "create";
    },
    editMode() {
      return this.mode === "edit";
    },
    settingsMode() {
      return this.mode === "settings";
    },
    connectionSupportMode() {
      return this.mode === "connectionSupport";
    },
    width() {
      if (
        this.mode === "create" ||
        this.mode === "edit" ||
        this.mode === "containerConfig"
      ) {
        return 700;
      }
      return 500;
    },
  },

  methods: {
    closeModal() {
      this.show = false;
      this.userId = undefined;
    },
    getModalClass() {
      if (this.mode == "create" || this.mode == "edit") {
        return "modal modal-round modal-device";
      }
      return "modal modal-round";
    },
    async reset() {
      this.userId = undefined;
      this.mode = "create";
      EventBus.$emit("RESET_DEVICE_MODAL", {});
    },

    async edit(id) {
      this.mode = "edit";
      this.show = true;
      const device = await this.$api.devices.find({ id });
      this.$nextTick(() =>
        EventBus.$emit("RESET_DEVICE_EDIT_MODAL", {
          device,
        })
      );
    },

    async containerConfig(id) {
      this.show = true;
      this.mode = "containerConfig";

      let device = await this.$api.devices.findContainerConfig(id);
      try {
        device.container.statusBoxService =
          await this.$api.devices.getStatusBoxService(device.container.id);
      } catch (Exception) {
        console.log("Problema ao carregar status do container");
      }
    },

    async settings(params) {
      this.show = true;
      this.mode = "settings";
      this.userId = params.userId;

      const config = await this.$api.devices.findConfiguration({
        id: params.id,
        userId: params.userId,
      });
      this.$nextTick(() =>
        EventBus.$emit("RESET_SETTINGS_MODAL", {
          config: config,
          id: params.id,
          name: params.name,
        })
      );
    },

    async connectionSupport(params) {
      this.show = true;
      this.mode = "connectionSupport";

      const config = await this.$api.devices.findConnectionSupport(params.id);
      config.deviceId = params.id;
      this.$nextTick(() =>
        EventBus.$emit("RESET_DEVICE_CONNECTION_SUPPORT_MODAL", {
          config: config,
          id: params.id,
          name: params.name,
          isWifeedAtivo: params.isWifeedAtivo,
        })
      );
    },
  },
  mounted() {
    EventBus.$on("EDIT_DEVICE_DATA", this.edit);
    EventBus.$on("EDIT_DEVICE_SETTINGS", this.settings);
    EventBus.$on("EDIT_DEVICE_CONNECTION_SUPPORT_DATA", this.connectionSupport);
  },

  beforeDestroy() {
    EventBus.$off("EDIT_DEVICE_DATA", this.edit);
    EventBus.$off("EDIT_DEVICE_SETTINGS", this.settings);
    EventBus.$off(
      "EDIT_DEVICE_CONNECTION_SUPPORT_DATA",
      this.connectionSupport
    );
  },
};
</script>

<style lang="scss" scoped>
.v-dialog__content {
  border-radius: 5px;
}
.modal {
  border-radius: 5px;
}

.v-stepper {
  overflow: visible !important;
  overflow-y: visible !important;
}
.v-card {
  padding: 10px !important;
}
</style>
